import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = ({ children, hideFooter = false, hideHeader = false, headerVariant = "default" }) => {
  return (
    <>
      {!hideHeader && <Header variant={headerVariant} />}
      <main id="main" data-testid="main">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </>
  );
};
